module.exports = __webpack_public_path__ + "img/img4.c98f75b9.jpg";